import clsx from 'clsx';
import { forwardRef } from '@wordpress/element';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const noop = () => {};
function UnforwardedFormToggle(props, ref) {
  const {
    className,
    checked,
    id,
    disabled,
    onChange = noop,
    onClick,
    ...additionalProps
  } = props;
  const wrapperClasses = clsx('components-form-toggle', className, {
    'is-checked': checked,
    'is-disabled': disabled
  });
  return /*#__PURE__*/_jsxs("span", {
    className: wrapperClasses,
    children: [/*#__PURE__*/_jsx("input", {
      className: "components-form-toggle__input",
      id: id,
      type: "checkbox",
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      onClick: event => {
        // Compat code for Safari to ensure that the toggle is focused when clicked.
        event.currentTarget.focus();
        onClick?.(event);
      },
      ...additionalProps,
      ref: ref
    }), /*#__PURE__*/_jsx("span", {
      className: "components-form-toggle__track"
    }), /*#__PURE__*/_jsx("span", {
      className: "components-form-toggle__thumb"
    })]
  });
}

/**
 * FormToggle switches a single setting on or off.
 *
 * ```jsx
 * import { FormToggle } from '@wordpress/components';
 * import { useState } from '@wordpress/element';
 *
 * const MyFormToggle = () => {
 *   const [ isChecked, setChecked ] = useState( true );
 *
 *   return (
 *     <FormToggle
 *       checked={ isChecked }
 *       onChange={ () => setChecked( ( state ) => ! state ) }
 *     />
 *   );
 * };
 * ```
 */
export const FormToggle = forwardRef(UnforwardedFormToggle);
FormToggle.displayName = 'FormToggle';
export default FormToggle;